import { useState } from 'react';

interface PasswordFieldProps {
  label: string;
  name: string;
  autoComplete: 'current-password' | 'new-password';
  minLength?: number;
  hint?: string;
  meter?: boolean;
}

function score(value: string): number {
  if (!value) return 0;
  let points = 0;
  if (value.length >= 10) points += 1;
  if (value.length >= 14) points += 1;
  if (/[A-Z]/.test(value) && /[a-z]/.test(value)) points += 1;
  if (/\d/.test(value) && /[^A-Za-z0-9]/.test(value)) points += 1;
  return Math.max(1, Math.min(4, points));
}

export default function PasswordField({ label, name, autoComplete, minLength, hint, meter }: PasswordFieldProps) {
  const [visible, setVisible] = useState(false);
  const [value, setValue] = useState('');

  return (
    <label className="field">
      <span>{label}</span>
      <span className="sa-password">
        <input
          className="input"
          type={visible ? 'text' : 'password'}
          name={name}
          required
          minLength={minLength}
          autoComplete={autoComplete}
          value={value}
          onChange={event => setValue(event.target.value)}
        />
        <button type="button" onClick={() => setVisible(current => !current)} aria-pressed={visible} aria-label={visible ? 'Hide password' : 'Show password'}>
          {visible ? 'Hide' : 'Show'}
        </button>
      </span>
      {meter ? (
        <span className="sa-strength" data-score={score(value)} aria-hidden="true">
          <i />
          <i />
          <i />
          <i />
        </span>
      ) : null}
      {hint ? <small>{hint}</small> : null}
    </label>
  );
}
